import './style.css'
import Experience from './Experience/Experience.js'

const experience = new Experience(document.querySelector('canvas.webgl'))

// /**
//  * Base
//  */
// // Debug
// const gui = new dat.GUI()

// // Canvas
// const canvas = document.querySelector('canvas.webgl')

// // Scene
// const scene = new THREE.Scene()

// /**
//  * Models
//  */
// const dracoLoader = new DRACOLoader()
// dracoLoader.setDecoderPath('/draco/')

// const gltfLoader = new GLTFLoader()
// gltfLoader.setDRACOLoader(dracoLoader)

// const threeMFLoader = new ThreeMFLoader()


// let mixer = null

// gltfLoader.load(
//     '/models/Table/testeTabela2.gltf',
//     (gltf) =>
//     {
//         console.log(gltf)
//         // gltf.scene.rotation.y = Math.PI
//         // const children = [...gltf.scene.children] // 'spread operator' Taking the values and not the array
//         // console.log(children);
//         // gltf.scene.children[0].children[0].rotation.x = Math.PI
//         // gltf.scene.children[0].children[0].scale.set(0.001, 0.001, 0.001)
//         // gltf.scene.children[0].children[0].position.set(0, 0, 0)
//         // gltf.scene.children[0].children[0].castShadow = true
//         // gltf.scene.children[0].children[0].receiveShadow = true

//         // gltf.scene.traverse((child) =>
//         // {
//         //     if(child instanceof THREE.Mesh)
//         //     {
//         //         // console.log(child);
//         //         child.castShadow = true
//         //         child.receiveShadow = true
//         //     }
//         // })

//         gltf.scene.position.set(0, -0.2, 0)
//         scene.add(gltf.scene)
        
//         // for(const child of children)
//         // {
//             // child.castShadow = true
//             // child.receiveShadow = true
//         //     console.log(child)
//         //     scene.add(child)
//         // }
        
//         // scene.add(gltf.scene)

//         // // Animation
//         // // mixer = new THREE.AnimationMixer(gltf.scene)
//         // // const action = mixer.clipAction(gltf.animations[2])
//         // // action.play()
//     }
// )

// /**
//  * Lights
//  */
// const ambientLight = new THREE.AmbientLight(0xffffff, 1)

// const directionalLight1 = new THREE.DirectionalLight(0xffffff, 0.5)
// const directionalLightHelper1 = new THREE.DirectionalLightHelper(directionalLight1)
// directionalLight1.castShadow = true
// directionalLight1.shadow.mapSize.set(1024, 1024)
// directionalLight1.shadow.camera.far = 15
// directionalLight1.shadow.camera.left = - 7
// directionalLight1.shadow.camera.top = 7
// directionalLight1.shadow.camera.right = 7
// directionalLight1.shadow.camera.bottom = - 7
// directionalLight1.rotation.z = Math.PI * 0.5
// directionalLight1.position.set(-0.8, 0, 0)

// const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.6)
// const directionalLightHelper2 = new THREE.DirectionalLightHelper(directionalLight2)
// directionalLight2.castShadow = true
// directionalLight2.shadow.mapSize.set(1024, 1024)
// directionalLight2.shadow.camera.far = 15
// directionalLight2.shadow.camera.left = - 7
// directionalLight2.shadow.camera.top = 7
// directionalLight2.shadow.camera.right = 7
// directionalLight2.shadow.camera.bottom = - 7
// directionalLight2.rotation.z = Math.PI * (- 0.5)
// directionalLight2.position.set(0.8, 0, 0)

// const pointLight = new THREE.PointLight(0xffff0c, 1)
// const pointLightHelper = new THREE.PointLightHelper(pointLight)
// pointLight.castShadow = true
// pointLight.shadow.mapSize.set(1024, 1024)
// pointLight.shadow.camera.far = 15
// pointLight.position.set(-0.097, -0.215, 0.0)

// scene.add(ambientLight)
// scene.add(directionalLight1)
// scene.add(directionalLight2)
// scene.add(pointLight)
// // scene.add(pointLightHelper)

// // Debug
// const ambLightDebug = gui.addFolder('ambLight')
// ambLightDebug.close()
// ambLightDebug.add(ambientLight, 'intensity').min(0).max(10).step(0.001).name('intensity')

// const dirLight1Debug = gui.addFolder('dirLight1')
// dirLight1Debug.add(directionalLight1.position, 'x').min(-3).max(0).step(0.001).name('dirLight1X')
// dirLight1Debug.add(directionalLight1.position, 'y').min(-2).max(2).step(0.001).name('dirLight1Y')
// dirLight1Debug.add(directionalLight1.position, 'z').min(-2).max(2).step(0.001).name('dirLight1Z')

// dirLight1Debug.add(directionalLight1, 'intensity').min(0).max(10).step(0.001).name('dirLightIntensity1')

// const dirLight2Debug = gui.addFolder('dirLight2')
// dirLight2Debug.add(directionalLight2.position, 'x').min(0).max(3).step(0.001).name('dirLight2X')
// dirLight2Debug.add(directionalLight2.position, 'y').min(-2).max(2).step(0.001).name('dirLight2Y')
// dirLight2Debug.add(directionalLight2.position, 'z').min(-2).max(2).step(0.001).name('dirLight2Z')

// dirLight2Debug.add(directionalLight1, 'intensity').min(0).max(10).step(0.001).name('dirLightIntensity2')

// const pointLightDebug = gui.addFolder('pointLight')
// pointLightDebug.add(pointLight.position, 'x').min(-1).max(1).step(0.001).name('pointLightX')
// pointLightDebug.add(pointLight.position, 'y').min(-1).max(1).step(0.001).name('pointLightY')
// pointLightDebug.add(pointLight.position, 'z').min(-1).max(1).step(0.001).name('pointLightZ')

// pointLightDebug.add(pointLight, 'intensity').min(0).max(10).step(0.001).name('pointLightIntensity')

// scene.add(directionalLightHelper1)
// scene.add(directionalLightHelper2)

// /**
//  * Sizes
//  */
// const sizes = {
//     width: window.innerWidth,
//     height: window.innerHeight
// }

// window.addEventListener('resize', () =>
// {
//     // Update sizes
//     sizes.width = window.innerWidth
//     sizes.height = window.innerHeight

//     // Update camera
//     camera.aspect = sizes.width / sizes.height
//     camera.updateProjectionMatrix()

//     // Update renderer
//     renderer.setSize(sizes.width, sizes.height)
//     renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
// })

// /**
//  * Camera
//  */
// // Base camera
// const camera = new THREE.PerspectiveCamera(15, sizes.width / sizes.height, 0.1, 100)
// camera.position.set(1, 1.6, 1.6)

// const camDebug = gui.addFolder('camera')
// camDebug.add(camera.position, 'x').min(-2).max(2).step(0.001).name('cameraX')
// camDebug.add(camera.position, 'y').min(-2).max(2).step(0.001).name('cameraY')
// camDebug.add(camera.position, 'z').min(-2).max(2).step(0.001).name('cameraZ')

// function updateCamera() {
//     camera.updateProjectionMatrix();
//     }

// camDebug.add(camera, 'fov', 1, 180).onChange(updateCamera);

// scene.add(camera)

// // Controls
// const controls = new OrbitControls(camera, canvas)
// controls.target.set(0, 0, 0)

// const constrolsDebug = gui.addFolder('controls')
// constrolsDebug.add(controls.target, 'x').min(-1).max(1).step(0.001).name('targetX')
// constrolsDebug.add(controls.target, 'y').min(-1).max(1).step(0.001).name('targetY')
// constrolsDebug.add(controls.target, 'z').min(-1).max(1).step(0.001).name('targetZ')

// controls.enableDamping = true

// /**
//  * Renderer
//  */
// const renderer = new THREE.WebGLRenderer({
//     canvas: canvas,
//     antialias: true
// })
// renderer.shadowMap.enabled = true
// renderer.shadowMap.type = THREE.PCFSoftShadowMap
// renderer.setSize(sizes.width, sizes.height)
// renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// // Clear color
// const debugObject = {}
// debugObject.clearColor = new THREE.Color('#000000')
// renderer.setClearColor(debugObject.clearColor)

// gui.addColor(debugObject, 'clearColor').name('clearColor').onChange(() =>
// {
//     renderer.setClearColor(debugObject.clearColor)
// })

// /**
//  * Animate
//  */
// const clock = new THREE.Clock()
// let previousTime = 0

// const tick = () =>
// {
//     const elapsedTime = clock.getElapsedTime()
//     const deltaTime = elapsedTime - previousTime
//     previousTime = elapsedTime

//     // Model animation
//     if(mixer)
//     {
//         mixer.update(deltaTime)
//     }

//     // Update controls
//     controls.update()

//     // Render
//     renderer.render(scene, camera)

//     // Call tick again on the next frame
//     window.requestAnimationFrame(tick)
// }

// tick()